export default "__VITE_ASSET__176b1650__"